module.exports = __webpack_public_path__ + "static/hero_art@2x-e66cc6232611809a8d53229a7c407dc7.png";